import { FileWithPath, Dropzone as MantineDropzone } from "@mantine/dropzone";

import SearchSimilarPartDropzoneStatus from "#modules/quoteRequestLines/SearchSimilarPartDropzoneStatus";
import { useDropzoneHandlers, DROPZONE_MAX_SIZE } from "#shared/hooks/useDropzoneHandlers";

type Props = {
  onDrop: (files: FileWithPath[]) => void;
  loading?: boolean;
  title: string;
  multiple?: boolean;
  illustration: string;
  classes: Partial<{
    dropzone: string;
    search: string;
  }>;
  uploadProgress?: number;
  progressBarColor?: string;
  validFileTypeText?: string;
  validExtensions?: string[];
  accept?: Record<string, string[]>;
  maxSize?: number;
};

export const HomeDropZone = ({
  onDrop,
  loading,
  classes,
  title,
  maxSize = DROPZONE_MAX_SIZE,
  multiple = false,
  illustration,
  uploadProgress,
  progressBarColor,
  validFileTypeText = "Rechercher...",
  validExtensions = [],
  accept = {},
}: Props) => {
  const { inputAccept, validator, handleReject } = useDropzoneHandlers(accept, validExtensions);

  return (
    <MantineDropzone
      onDrop={onDrop}
      onReject={handleReject}
      maxSize={maxSize}
      validator={validator}
      inputProps={{ accept: inputAccept }}
      multiple={multiple}
      loading={loading}
      className={`${classes.dropzone!} ${classes.search!}`}
      loaderProps={{
        color: progressBarColor,
      }}
    >
      <MantineDropzone.Idle>
        <SearchSimilarPartDropzoneStatus
          message={title}
          illustration={illustration}
          uploadProgress={uploadProgress}
          progressBarColor={progressBarColor}
        />
      </MantineDropzone.Idle>

      <MantineDropzone.Accept>
        <SearchSimilarPartDropzoneStatus illustration={illustration} message={validFileTypeText} />
      </MantineDropzone.Accept>

      <MantineDropzone.Reject>
        <SearchSimilarPartDropzoneStatus
          illustration={illustration}
          message="Type de fichier invalide"
        />
      </MantineDropzone.Reject>
    </MantineDropzone>
  );
};
